var exports = {
  "ed": "PurchaseDisclaimer.module__disclaimer___VTE1bD",
  "gX": "PurchaseDisclaimer.module__center___VTE1bD",
  "kb": "PurchaseDisclaimer.module__left___VTE1bD",
};

module.exports = exports;
